import React, { useMemo } from 'react';
import { ProcessingType } from '@/shared/models/ContextDataModel/interfaces/enums/processing-type.ts';
import { ProcessingTypeToggle } from './components/ProcessingTypeToggle';
import { ProductTemplateList } from './components/ProductTemplateList';
import { ProductTemplateOption, ProductTemplateSelectedOption } from './types';
import { AUTOMATIC_FULFILLMENT_OPTIONS } from './config/automaticFulfillmentOptions';
import { MANUAL_FULFILLMENT_OPTIONS } from './config/manualFulfillmentOptions';

type ProductTemplateSelectionProps = {
    processingType: ProcessingType;
    onChangeProcessingType: (processingType: ProcessingType) => void;
    onSelect: (option: ProductTemplateSelectedOption) => void;
};

export const ProductTemplateSelection = ({
    processingType,
    onChangeProcessingType,
    onSelect,
}: ProductTemplateSelectionProps) => {
    const isExpandable = processingType === 'MANUAL';

    const options = useMemo((): ProductTemplateOption[] => {
        return processingType === 'MANUAL' ? MANUAL_FULFILLMENT_OPTIONS : AUTOMATIC_FULFILLMENT_OPTIONS;
    }, [processingType]);

    return (
        <div className="flex w-full flex-col gap-8">
            <ProcessingTypeToggle value={processingType} onChange={onChangeProcessingType} />
            <ProductTemplateList options={options} isExpandable={isExpandable} onSelect={onSelect} />
        </div>
    );
};
